export const OUTIL_COLORS = {
  background: "#edf2f8",
  border: "#c8d6e5",
  gold: "#d5ad3f",
  navy: "#173d61",
  panelHeader: "#e8eef5",
  text: "#10263d",
  textMuted: "#60758a",
};

export const pageSx = {
  backgroundColor: OUTIL_COLORS.background,
  boxSizing: "border-box",
  color: OUTIL_COLORS.text,
  fontFamily: "'DM Sans', sans-serif",
  minHeight: "calc(100vh - 56px)",
  px: { xs: 1.5, sm: 2.5 },
  py: 2,
};

export const paperSx = {
  border: `1px solid ${OUTIL_COLORS.border}`,
  borderRadius: "10px",
  boxShadow: "0 2px 8px rgba(16, 38, 61, 0.05)",
};

export const fieldSx = {
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    borderRadius: "6px",
    fontSize: 12,
  },
  "& .MuiInputLabel-root": {
    color: "#526b84",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
  },
};

export const tableHeaderSx = {
  backgroundColor: OUTIL_COLORS.navy,
  color: "#fff",
  fontSize: 10,
  fontWeight: 700,
  whiteSpace: "nowrap",
};
